const query = variable => {
    let query = window.location.search;
    let vars = query.replace('?', '').split("&");
    for (let i=0;i<vars.length;i++) {
        let pair = vars[i].split("=");
        if(pair[0] === variable){return pair[1];}
    }
    return false;
}

export const isPathMatched = variable => {
    const path = window.location.href;
    return path.includes(variable);
}

export default query;